
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 6h26v20h-9.563l-2.719 2.719-.719.688-.719-.688L12.561 26H2.998V6zm2 2v16h8.406l.313.281L16 26.562l2.281-2.281.313-.281H27V8H5zm4 3h14v2H9v-2zm0 4h14v2H9v-2zm0 4h10v2H9v-2z"}})])
          )
        }
      }
    